/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum Shared_AttributeTypes {
    Text = 10,
    Integer = 20,
    Decimal = 25,
    Bool = 30,
    Reference = 80,
    List = 90,
}
